'use client';

// Registra el service worker de la PWA (Serwist) solo en producción: en `next dev` no existe
// public/sw.js (lo genera `serwist build`) y la caché interferiría con la recarga en caliente.
import { SerwistProvider } from '@serwist/next/react';
import type { ReactNode } from 'react';

export function PwaProvider({ children }: { children: ReactNode }) {
  return (
    <SerwistProvider swUrl="/sw.js" disable={process.env.NODE_ENV !== 'production'}>
      {children}
    </SerwistProvider>
  );
}
